












































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import PrefillMixin from "@/mixins/PrefillMixin";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import PanelBblKebidanan from "@/components/pemeriksaan/assesmen/PanelBblKebidanan.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import AsesmenAwalRanapKebidananSvc from "@/services/AsesmenAwalRanapKebidanan";
import AsesmenAwalRanapKebidananStore from "@/store/modules/AsesmenAwalRanapKebidananStore";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePerawat } from "@/store/modules/perawat";
import {
  calculateTbj,
  calculateTpAdjusted,
  calculateUsiaKehamilan,
  calculateTrimester,
  calculateStatusKehamilan,
  calculateSisaHari,
  calculateMap
} from "@/utils/kebidananCalculator";

const TTV_PULL_PATHS: string[] = [
  "pemeriksaan_fisik.gcs.e",
  "pemeriksaan_fisik.gcs.v",
  "pemeriksaan_fisik.gcs.m",
  "pemeriksaan_fisik.ttv.td_sistole",
  "pemeriksaan_fisik.ttv.td_diastole",
  "pemeriksaan_fisik.ttv.nadi",
  "pemeriksaan_fisik.ttv.respirasi",
  "pemeriksaan_fisik.ttv.suhu",
  "pemeriksaan_fisik.ttv.spo2",
  "pemeriksaan_fisik.ttv.bb",
  "pemeriksaan_fisik.ttv.tb",
  "pemeriksaan_fisik.abdomen.tfu_cm"
];

function strToDate(v: unknown): Date | null {
  if (!v) return null;
  const [y, m, d] = String(v)
    .slice(0, 10)
    .split("-")
    .map(Number);
  return y && m && d ? new Date(y, m - 1, d) : null;
}

function pad2(n: number): string {
  return String(n).padStart(2, "0");
}

@Component({
  components: {
    CardModalTtd,
    PanelBblKebidanan,
    PersonAutoComplete,
    VCDateTimePicker
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class AsesmenAwalKebidananPage extends Mixins(PrefillMixin) {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: false }) isActive!: boolean;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  // ── Soft-prefill (FormPrefill engine) ──────────────────────────────
  prefillFormKey = "asesmen_awal_ranap_kebidanan";

  /**
   * Path relatif this.form — hanya key yang sudah ada di getEmptyForm()
   * yang diisi (reaktif). Path lain di-skip.
   */
  prefillResolvePath(path: string) {
    const segments = path.split(".");
    const last = segments.pop() as string;
    const parent = segments.reduce(
      (acc: any, seg) => (acc == null ? acc : acc[seg]),
      this.form
    );
    if (parent && Object.prototype.hasOwnProperty.call(parent, last)) {
      return {
        get: () => parent[last],
        set: v => {
          parent[last] = v;
        }
      };
    }
    return { get: () => "__skip__", set: () => undefined };
  }

  ttvLoading = false;

  private ttvSnapshot(): string {
    return TTV_PULL_PATHS.map(p => {
      const v = this.prefillResolvePath(p).get();
      return v === null || v === undefined ? "" : String(v);
    }).join("|");
  }

  async ambilDariMonitorTtv() {
    if (this.readOnly || this.ttvLoading) return;
    if (!this.rm) {
      appModule.sendErrorNotice("No. RM pasien tidak tersedia.");
      return;
    }

    this.ttvLoading = true;
    try {
      const sebelum = this.ttvSnapshot();
      this.prefillPayload = null;
      await this.loadPrefill({
        pasien_rm: String(this.rm),
        register_id: this.register,
        unit_id: this.stateuser ? this.stateuser.unit_id : undefined,
        sources: ["klinis_terkini"]
      });

      const jumlahField = Object.keys(this.prefillPayload?.fields || {}).length;

      const abd = this.form?.pemeriksaan_fisik?.abdomen;
      if (abd && abd.tfu_cm != null && abd.tfu_cm !== "" && !abd.tfu_teks) {
        abd.tfu_mode = "cm";
      }

      if (this.ttvSnapshot() !== sebelum) {
        appModule.NoticeDelay(
          "Data terakhir kunjungan ini disalin ke kolom yang masih kosong."
        );
      } else if (jumlahField > 0) {
        appModule.NoticeDelay(
          "Semua kolom sudah terisi — nilai yang ada tidak ditimpa."
        );
      } else {
        appModule.sendErrorNotice(
          "Belum ada data TTV/antropometri pada kunjungan ini. Isi Monitor TTV terlebih dahulu."
        );
      }
    } finally {
      this.ttvLoading = false;
    }
  }
  // ───────────────────────────────────────────────────────────────────

  loading = false;
  saving = false;
  isEditing = false;
  formValid = false;
  modalTtd = false;
  signRole = "";

  viewPanels: number[] = [];
  formPanels: number[] = Array.from({ length: 14 }, (_, i) => i);

  pemeriksaanUmumAreas = [
    { key: "rambut", label: "Rambut" },
    { key: "mata", label: "Mata" },
    { key: "telinga", label: "Telinga" },
    { key: "gigi_mulut", label: "Gigi dan Mulut" },
    { key: "leher", label: "Leher" },
    { key: "dada", label: "Dada" }
  ];

  golDarahOptions = ["A", "B", "AB", "O"];
  rhesusOptions = ["+", "-", "Belum diketahui"];
  hubunganSuamiOptions = [
    "Suami sah",
    "Pasangan tidak menikah",
    "Orangtua",
    "Saudara",
    "Wali"
  ];

  // Letak odema — lokasi spesifik (deteksi dini pre-eklampsia)
  oedemaLokasiOptions = [
    "Wajah/Periorbital",
    "Palpebra",
    "Jari Tangan",
    "Pergelangan Tangan",
    "Tungkai Bawah Pretibial",
    "Ankle/Pergelangan Kaki",
    "Dorsum Pedis/Punggung Kaki",
    "Genitalia/Vulva",
    "Sakral",
    "Generalisata/Anasarka"
  ];
  oedemaDerajatOptions = ["+1", "+2", "+3", "+4"];
  // Lokasi edema yang menjadi red-flag PEB (bukan edema fisiologis tungkai)
  oedemaRedFlag = [
    "Wajah/Periorbital",
    "Palpebra",
    "Jari Tangan",
    "Pergelangan Tangan",
    "Sakral",
    "Generalisata/Anasarka"
  ];

  // Letak janin (Leopold)
  letakJaninOptions = [
    "Longitudinal/Memanjang",
    "Transversal/Lintang",
    "Oblique/Miring",
    "Sulit ditentukan"
  ];
  presentasiDetailOptions = [
    "Kepala (Vertex)",
    "Bokong (Breech)",
    "Bahu (Shoulder)",
    "Muka (Face)",
    "Dahi (Brow)",
    "Compound"
  ];
  posisiJaninOptions = [
    "LOA",
    "ROA",
    "LOP",
    "ROP",
    "LOT",
    "ROT",
    "Belum ditentukan"
  ];
  sikapJaninOptions = ["Fleksi sempurna", "Defleksi", "Hiperekstensi"];
  engagementOptions = ["Sudah engaged", "Belum engaged (floating)"];

  // Pilihan vulva — multi-select (standardisasi pemeriksaan genitalia eksterna)
  vulvaTemuanOptions = [
    "Normal",
    "Hiperpigmentasi",
    "Edema vulva",
    "Varises vulva",
    "Hematoma vulva",
    "Kondiloma akuminata",
    "Kondiloma lata",
    "Vesikel/lesi Herpes",
    "Ulkus",
    "Fluor albus/Leukorea",
    "Perdarahan pervaginam",
    "Pengeluaran air ketuban",
    "Lochia (postpartum)",
    "Bekas jahitan/episiotomi",
    "Tampak bagian janin"
  ];

  form: any = this.getEmptyForm();

  mounted() {
    this.loadData();
    if (!storePerawat.listPerawat.length) {
      storePerawat.actListPerawatall();
    }
    if (!storePerawat.listKaryawan.length) {
      storePerawat.actListKaryawanAll();
    }
  }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val && !this.record) {
      this.loadData();
    }
  }

  get record() {
    return AsesmenAwalRanapKebidananStore.asesmen;
  }

  get viewContent() {
    return (this.record && this.record.content) || {};
  }

  get stateuser() {
    return userModule.user;
  }

  get listBidan() {
    return storePerawat.listPerawat;
  }

  togglePenolongManual(rp: any) {
    this.$set(rp, "penolong_manual", !rp.penolong_manual);
    this.$set(rp, "penolong", "");
  }

  isPenolongLuarRsps(penolong: any) {
    if (!penolong) return false;
    const list = storePerawat.listKaryawan as Array<{ nama: string }>;
    if (!list.length) return false;
    return !list.some(it => it && it.nama === penolong);
  }

  get canEdit() {
    if (!this.record) return false;
    if (this.record.is_fully_signed) return false;
    if (!userModule.canAccessForm("asesmen_awal_ranap_kebidanan", "edit"))
      return false;
    return [this.record.bidan_user_id, this.record.creator_user_id].includes(
      this.stateuser.id
    );
  }

  get canEditState() {
    if (this.readOnly) return false;
    if (!this.record) return false;
    if (this.canUpdateSigned) return true;
    if (this.record.is_fully_signed) return false;
    return [this.record.bidan_user_id, this.record.creator_user_id].includes(
      this.stateuser.id
    );
  }

  get canDelete() {
    if (!this.record) return false;
    if (!userModule.canAccessForm("asesmen_awal_ranap_kebidanan", "edit"))
      return false;
    return !this.record.is_fully_signed;
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("asesmen_awal_ranap_kebidanan", "create");
  }

  get canUpdateSigned(): boolean {
    return userModule.hasPrivilege("asesmen_awal_ranap_kebidanan", "update_signed");
  }

  get canSignBidan() {
    if (!this.record) return false;
    return (
      !this.record.signed_bidan &&
      this.record.bidan_user_id == this.stateuser.id
    );
  }

  get canSignDpjp() {
    if (!this.record) return false;
    return !this.record.signed_dpjp;
  }

  get canSignBpja() {
    if (!this.record) return false;
    // BPJA harus berbeda dari bidan pelaksana (dual-control asuhan)
    return (
      !this.record.signed_bpja && this.record.bidan_user_id != this.stateuser.id
    );
  }

  g(path: string, def: any = null): any {
    const keys = path.split(".");
    let obj: any = this.viewContent;
    for (const k of keys) {
      if (obj == null) return def;
      obj = obj[k];
    }
    return obj != null ? obj : def;
  }

  // ===== Riwayat perkawinan =====
  get statusPerkawinanItems(): string[] {
    return ["Belum Menikah", "Tercatat", "Tidak Tercatat"];
  }

  get belumMenikah(): boolean {
    return this.form?.riwayat_obstetri?.perkawinan?.status === "Belum Menikah";
  }

  onStatusPerkawinanChange() {
    if (!this.belumMenikah) return;
    const kawin = this.form.riwayat_obstetri.perkawinan;
    kawin.nikah_kali = null;
    kawin.suami_sekarang_tahun = null;
    kawin.suami_sekarang_bulan = null;
    kawin.pertama_umur = null;
  }

  // ===== TFU: mode cm (angka, memberi TBJ) atau deskripsi (teks bebas) =====
  get tfuModeItems() {
    return [
      { text: "cm", value: "cm" },
      { text: "Deskripsi", value: "teks" }
    ];
  }

  get tfuModeForm(): string {
    return this.form?.pemeriksaan_fisik?.abdomen?.tfu_mode || "cm";
  }

  onTfuModeChange() {
    const abd = this.form?.pemeriksaan_fisik?.abdomen;
    if (!abd) return;
    if (!abd.tfu_mode) abd.tfu_mode = "cm";
    if (abd.tfu_mode === "cm") {
      abd.tfu_teks = "";
    } else {
      abd.tfu_cm = null;
    }
  }

  get tfuViewLabel(): string {
    const abd = this.g("pemeriksaan_fisik.abdomen") || {};
    if ((abd.tfu_mode || "cm") === "teks") return abd.tfu_teks || "-";
    return abd.tfu_cm != null && abd.tfu_cm !== "" ? `${abd.tfu_cm} cm` : "-";
  }

  get tbjView(): number | null {
    const abd = this.g("pemeriksaan_fisik.abdomen") || {};
    if (this.isGemelliView) return null;
    if ((abd.tfu_mode || "cm") === "teks") return null;
    const tfu = abd.tfu_cm;
    const hodge = this.g("pemeriksaan_fisik.abdomen.penurunan_hodge");
    return calculateTbj(
      typeof tfu === "number" ? tfu : parseFloat(tfu),
      Number(hodge) >= 3
    );
  }

  get tbjForm(): number | null {
    const abd = this.form?.pemeriksaan_fisik?.abdomen || {};
    if (this.isGemelliForm) return null;
    if ((abd.tfu_mode || "cm") === "teks") return null;
    const tfu =
      typeof abd.tfu_cm === "number" ? abd.tfu_cm : parseFloat(abd.tfu_cm);
    return calculateTbj(tfu, Number(abd.penurunan_hodge) >= 3);
  }

  // ===== Jumlah janin: tunggal (default) atau gemelli =====
  get isGemelliForm(): boolean {
    return Number(this.form?.pemeriksaan_fisik?.abdomen?.jumlah_janin) >= 2;
  }

  get isGemelliView(): boolean {
    return Number(this.g("pemeriksaan_fisik.abdomen.jumlah_janin")) >= 2;
  }

  get janinBlocksForm(): any[] {
    const abd = this.form?.pemeriksaan_fisik?.abdomen;
    if (!abd) return [];
    const blocks: any[] = [{ key: "janin_1", label: "Janin 1", data: abd }];
    if (this.isGemelliForm)
      blocks.push({ key: "janin_2", label: "Janin 2", data: abd.janin_2 });
    return blocks;
  }

  get janinBlocksView(): any[] {
    const abd = this.g("pemeriksaan_fisik.abdomen") || {};
    const blocks: any[] = [{ key: "janin_1", label: "Janin 1", data: abd }];
    if (this.isGemelliView)
      blocks.push({
        key: "janin_2",
        label: "Janin 2",
        data: abd.janin_2 || {}
      });
    return blocks;
  }

  jg(data: any, path: string, def: any = null): any {
    let obj: any = data;
    for (const k of path.split(".")) {
      if (obj == null) return def;
      obj = obj[k];
    }
    return obj != null ? obj : def;
  }

  // ===== Jejak pembuat asesmen (siapa yang boleh menyunting) =====
  get pembuatNama(): string {
    return (
      (this.record && this.record.creator && this.record.creator.nama) || "-"
    );
  }

  get bidanNama(): string {
    return (this.record && this.record.bidan && this.record.bidan.nama) || "-";
  }

  get dibuatPada(): string {
    const v = this.record ? this.record.created_at : null;
    const d = v ? new Date(v) : null;
    if (!d || isNaN(d.getTime())) return "";
    return `${pad2(d.getDate())}-${pad2(
      d.getMonth() + 1
    )}-${d.getFullYear()} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
  }

  // ===== Jembatan VCDateTimePicker <-> string lokal di this.form =====
  // Wajib computed (bukan method): method membangun Date baru tiap render.
  // Nilai tersimpan tetap "YYYY-MM-DD" / "HH:mm" — jangan pakai toISOString().
  get tglLahirSuamiDate(): Date | null {
    return strToDate(this.form?.identitas_suami?.tgl_lahir);
  }

  set tglLahirSuamiDate(v: Date | null) {
    this.form.identitas_suami.tgl_lahir = v ? localISODate(v) : "";
  }

  get hphtDate(): Date | null {
    return strToDate(this.form?.riwayat_obstetri?.haid?.hpmt);
  }

  set hphtDate(v: Date | null) {
    this.form.riwayat_obstetri.haid.hpmt = v ? localISODate(v) : null;
  }

  get waktuPengkajian(): Date | null {
    const d = strToDate(this.form?.examined_date);
    if (!d) return null;
    const [h, m] = String(this.form.examined_time || "00:00")
      .split(":")
      .map(Number);
    d.setHours(h || 0, m || 0, 0, 0);
    return d;
  }

  set waktuPengkajian(v: Date | null) {
    if (!v) {
      this.form.examined_date = "";
      this.form.examined_time = "";
      return;
    }
    this.form.examined_date = localISODate(v);
    this.form.examined_time = `${pad2(v.getHours())}:${pad2(v.getMinutes())}`;
  }

  // ===== Auto-calculate HPHT/HPL (Naegele) — mode form =====
  get hplComputed(): string | null {
    const haid = this.form?.riwayat_obstetri?.haid || {};
    return calculateTpAdjusted(haid.hpmt, Number(haid.siklus) || null);
  }

  get ukComputed(): { minggu: number; hari: number } | null {
    const haid = this.form?.riwayat_obstetri?.haid || {};
    return calculateUsiaKehamilan(haid.hpmt);
  }

  get ukLabel(): string {
    const uk = this.ukComputed;
    return uk ? `${uk.minggu} minggu ${uk.hari} hari` : "—";
  }

  get trimesterComputed(): string | null {
    const uk = this.ukComputed;
    return uk ? calculateTrimester(uk.minggu) : null;
  }

  get statusKehamilanComputed(): string | null {
    const uk = this.ukComputed;
    return uk ? calculateStatusKehamilan(uk.minggu) : null;
  }

  get sisaHariComputed(): number | null {
    return this.hplComputed ? calculateSisaHari(this.hplComputed) : null;
  }

  get mapForm(): number | null {
    const ttv = this.form?.pemeriksaan_fisik?.ttv || {};
    return calculateMap(
      Number(ttv.td_sistole) || null,
      Number(ttv.td_diastole) || null
    );
  }

  // ===== Alert klinis (mode form) =====
  get spo2Alert(): { type: string; msg: string } | null {
    const spo2 = Number(this.form?.pemeriksaan_fisik?.ttv?.spo2);
    if (!spo2) return null;
    if (spo2 < 90)
      return {
        type: "error",
        msg: `SpO₂ ${spo2}% — KRITIS: aktifkan kode biru maternal, konsul Sp.OG + Sp.An segera`
      };
    if (spo2 < 95)
      return {
        type: "warning",
        msg: `SpO₂ ${spo2}% — di bawah 95%: evaluasi penyebab & pertimbangkan oksigenasi 2-4 lpm`
      };
    return null;
  }

  get edemaPebAlert(): boolean {
    const lokasi: string[] =
      this.form?.pemeriksaan_fisik?.umum?.ekstremitas?.oedema_lokasi || [];
    return lokasi.some(l => this.oedemaRedFlag.includes(l));
  }

  get skriningGiziTotal(): number {
    const sg = this.form.skrining_gizi;
    return (
      (sg.asupan_berkurang ? 1 : 0) +
      (sg.gangguan_metabolisme ? 1 : 0) +
      (sg.perubahan_bb ? 1 : 0) +
      (sg.hb_rendah ? 1 : 0)
    );
  }

  get skriningGiziBerisiko(): boolean {
    return this.skriningGiziTotal >= 1;
  }

  async loadData() {
    this.loading = true;
    try {
      await AsesmenAwalRanapKebidananStore.getByRegister(this.register);
    } finally {
      this.loading = false;
    }
    // Record baru: soft-prefill hanya field kosong (GPA/HPHT/TTV baseline).
    // Tidak pernah pada record tersimpan / mode edit.
    if (!this.record && !this.isEditing && this.canCreate) {
      this.$nextTick(() => {
        this.loadPrefill({
          pasien_rm: String(this.rm),
          register_id: this.register,
          unit_id: this.stateuser ? this.stateuser.unit_id : undefined
        });
      });
    }
  }

  emptyLeopold() {
    return {
      l1: "",
      l2: "",
      l3: "",
      l4: "",
      letak_janin: "",
      presentasi_detail: "",
      posisi: "",
      sikap: "",
      engagement: ""
    };
  }

  emptyJaninFields() {
    return {
      presentasi: "",
      punggung: "",
      penurunan_hodge: null,
      djj: null,
      djj_teratur: true,
      gerak_janin_24jam: "",
      leopold: this.emptyLeopold()
    };
  }

  getEmptyForm() {
    const now = new Date();
    return {
      sumber_pengkajian: { dari: "klien", nama_lain: null, hubungan: null },
      identitas_suami: {
        nama: "",
        nik: "",
        tgl_lahir: "",
        pendidikan: "",
        pekerjaan: "",
        alamat: "",
        no_telp: "",
        gol_darah: "",
        rhesus: "",
        hubungan: "Suami sah",
        pengambil_keputusan: false
      },
      keluhan: "",
      riwayat_kehamilan: {
        klien_datang: "sendiri",
        rujukan_dari: null,
        emesis: { ada: false, usia_kehamilan: null },
        perdarahan: { ada: false, usia_kehamilan: null },
        kenceng_tgl: null,
        kenceng_pukul: null,
        ketuban_tgl: null,
        ketuban_pukul: null,
        lendir_darah_tgl: null,
        lendir_darah_pukul: null,
        keluar_darah_tgl: null,
        keluar_darah_pukul: null
      },
      riwayat_penyakit: {
        penyakit_diderita: { ada: false, detail: "" },
        penyakit_keturunan: { ada: false, detail: "" },
        riwayat_rawat: { ada: false, detail: "" },
        alergi: { ada: false, detail: "" }
      },
      riwayat_obstetri: {
        haid: {
          menarche: null,
          siklus: null,
          lama: null,
          keteraturan: "",
          nyeri: "",
          hpmt: null,
          hpl: null
        },
        perkawinan: {
          status: "",
          nikah_kali: null,
          suami_sekarang_tahun: null,
          suami_sekarang_bulan: null,
          pertama_umur: null
        },
        kb: { ada: false, jenis: "" },
        gravida: null,
        para: null,
        abortus: null,
        anak_hidup: null,
        riwayat_persalinan: [
          {
            tgl_lahir: "",
            usia_kehamilan: "",
            jenis: "",
            penolong: "",
            penolong_manual: false,
            bbl: null,
            komplikasi_nifas: "",
            hidup_mati: ""
          }
        ],
        anc: {
          total: null,
          oleh: [],
          trimester_1: { kali: null, tempat: "" },
          trimester_2: { kali: null, tempat: "" },
          trimester_3: { kali: null, tempat: "" }
        }
      },
      psikososial_spiritual: {
        komunikasi: [],
        bahasa: "",
        bahasa_lain: "",
        ekspresi: "",
        tinggal_dengan: "",
        tinggal_lain: "",
        agama: "",
        ibadah: ""
      },
      kebutuhan_harian: {
        eliminasi: "",
        istirahat: "",
        merokok: false,
        jamu: false,
        obat: false,
        obat_rutin: "",
        minuman_keras: false
      },
      skrining_gizi: {
        asupan_berkurang: false,
        gangguan_metabolisme: false,
        perubahan_bb: false,
        hb_rendah: false
      },
      nyeri: {
        ada: false,
        lokasi: "",
        skala: null,
        durasi_detik: null,
        frekuensi: null,
        jenis: ""
      },
      risiko_jatuh_morse: "",
      pemeriksaan_fisik: {
        gcs: { e: null, m: null, v: null },
        ttv: {
          tb: null,
          bb: null,
          lla: null,
          td_sistole: null,
          td_diastole: null,
          suhu: null,
          nadi: null,
          nadi_teratur: true,
          respirasi: null,
          respirasi_teratur: true,
          spo2: null
        },
        umum: {
          rambut: { normal: true, detail: "" },
          mata: {
            normal: true,
            konjungtiva: "",
            sklera: "",
            kelainan: "",
            detail: ""
          },
          telinga: { normal: true, detail: "" },
          gigi_mulut: { normal: true, detail: "" },
          leher: { normal: true, detail: "" },
          dada: { normal: true, detail: "" },
          suara_nafas: [],
          suara_jantung: "",
          ekstremitas: {
            oedem: false,
            varises: false,
            kelainan: "",
            oedema_lokasi: [],
            oedema_derajat: ""
          }
        },
        abdomen: {
          bekas_operasi: false,
          letak_bekas: "",
          massa_tumor: false,
          inspeksi: { normal: true, detail: "" },
          tfu_mode: "cm",
          tfu_cm: null,
          tfu_teks: "",
          his_interval_menit: null,
          his_durasi_detik: null,
          jumlah_janin: 1,
          ...this.emptyJaninFields(),
          janin_2: this.emptyJaninFields()
        },
        ginekologi: {
          vulva: "",
          vulva_temuan: [],
          periksa_dalam_oleh: "",
          hasil: ""
        }
      },
      penunjang: {
        laborat: [],
        usg: false,
        ctg: false,
        ekg: false,
        rontgen: false
      },
      perencanaan_pulang: {
        tinggal_bersama: "",
        penerangan: "",
        letak_kamar: "",
        wc_kloset: "",
        alat_bantu: { perlu: false, detail: "" },
        diet_khusus: { ada: false, detail: "" },
        perawatan_lanjutan: { perlu: false, detail: "" },
        rujukan_komunitas: { perlu: false, detail: "" }
      },
      kebutuhan_edukasi: {
        pasien_bertanya: "",
        kebutuhan_info: "",
        kognitif: { masalah: false, detail: "" },
        motivasi: { masalah: false, detail: "" },
        fisik: { masalah: false, detail: "" },
        penerjemah: { perlu: false, bahasa: "" }
      },
      barthel: "",
      risiko_dekubitus_braden: "",
      diagnosa_kebidanan: "",
      perencanaan: "",
      // Meta (non-content)
      bidan_user_id: (this.stateuser && this.stateuser.id) || null,
      examined_date: localISODate(now),
      examined_time: now.toTimeString().substr(0, 5)
    };
  }

  addRiwayatPersalinan() {
    this.form.riwayat_obstetri.riwayat_persalinan.push({
      tgl_lahir: "",
      usia_kehamilan: "",
      jenis: "",
      penolong: "",
      penolong_manual: false,
      bbl: null,
      komplikasi_nifas: "",
      hidup_mati: ""
    });
  }

  startEdit() {
    if (this.readOnly) return;
    const c = JSON.parse(JSON.stringify(this.record.content));
    this.form = {
      ...c,
      bidan_user_id: this.record.bidan_user_id,
      examined_date: this.record.examined_at
        ? this.record.examined_at.substr(0, 10)
        : "",
      examined_time: this.record.examined_at
        ? this.record.examined_at.substr(11, 5)
        : ""
    };
    // Ensure nested structures exist
    if (!this.form.pemeriksaan_fisik)
      this.form.pemeriksaan_fisik = this.getEmptyForm().pemeriksaan_fisik;
    if (!this.form.pemeriksaan_fisik.umum)
      this.form.pemeriksaan_fisik.umum = this.getEmptyForm().pemeriksaan_fisik.umum;
    if (!this.form.skrining_gizi)
      this.form.skrining_gizi = this.getEmptyForm().skrining_gizi;
    if (!this.form.riwayat_obstetri) {
      this.form.riwayat_obstetri = this.getEmptyForm().riwayat_obstetri;
    }
    if (!this.form.riwayat_obstetri.riwayat_persalinan) {
      this.form.riwayat_obstetri.riwayat_persalinan = [
        {
          tgl_lahir: "",
          usia_kehamilan: "",
          jenis: "",
          penolong: "",
          penolong_manual: false,
          bbl: null,
          komplikasi_nifas: "",
          hidup_mati: ""
        }
      ];
    }

    this.form.riwayat_obstetri.riwayat_persalinan.forEach((rp: any) => {
      if (rp.penolong_manual === undefined) {
        this.$set(rp, "penolong_manual", this.isPenolongLuarRsps(rp.penolong));
      }
    });
    // Defensive defaults untuk field fitur baru (record lama)
    const empty = this.getEmptyForm();
    this.form.identitas_suami = {
      ...empty.identitas_suami,
      ...(this.form.identitas_suami || {})
    };
    this.form.kebutuhan_harian = {
      ...empty.kebutuhan_harian,
      ...(this.form.kebutuhan_harian || {})
    };
    this.form.riwayat_penyakit = {
      ...empty.riwayat_penyakit,
      ...(this.form.riwayat_penyakit || {})
    };
    this.form.riwayat_obstetri.perkawinan = {
      ...empty.riwayat_obstetri.perkawinan,
      ...(this.form.riwayat_obstetri.perkawinan || {})
    };
    const pf = this.form.pemeriksaan_fisik;
    pf.ttv = { ...empty.pemeriksaan_fisik.ttv, ...(pf.ttv || {}) };
    pf.umum.ekstremitas = {
      ...empty.pemeriksaan_fisik.umum.ekstremitas,
      ...(pf.umum.ekstremitas || {})
    };
    pf.abdomen = { ...empty.pemeriksaan_fisik.abdomen, ...(pf.abdomen || {}) };
    pf.abdomen.leopold = {
      ...empty.pemeriksaan_fisik.abdomen.leopold,
      ...(pf.abdomen.leopold || {})
    };
    pf.abdomen.janin_2 = {
      ...empty.pemeriksaan_fisik.abdomen.janin_2,
      ...(pf.abdomen.janin_2 || {})
    };
    pf.abdomen.janin_2.leopold = {
      ...empty.pemeriksaan_fisik.abdomen.janin_2.leopold,
      ...(pf.abdomen.janin_2.leopold || {})
    };
    pf.abdomen.jumlah_janin = Number(pf.abdomen.jumlah_janin) >= 2 ? 2 : 1;
    pf.ginekologi = {
      ...empty.pemeriksaan_fisik.ginekologi,
      ...(pf.ginekologi || {})
    };
    if (!Array.isArray(pf.ginekologi.vulva_temuan))
      pf.ginekologi.vulva_temuan = [];
    if (!Array.isArray(pf.umum.ekstremitas.oedema_lokasi))
      pf.umum.ekstremitas.oedema_lokasi = [];
    this.isEditing = true;
  }

  cancelForm() {
    this.isEditing = false;
  }

  buildPayload() {
    const {
      bidan_user_id,
      examined_date,
      examined_time,
      ...contentFields
    } = this.form;

    // Compute skrining gizi
    contentFields.skrining_gizi.total = this.skriningGiziTotal;
    contentFields.skrining_gizi.berisiko = this.skriningGiziBerisiko;

    // Persist nilai turunan obstetri (HPL/UK/trimester/status) untuk PDF & audit
    if (contentFields.riwayat_obstetri && contentFields.riwayat_obstetri.haid) {
      const haid = contentFields.riwayat_obstetri.haid;
      haid.hpl = this.hplComputed || haid.hpl || null;
      const uk = this.ukComputed;
      haid.uk_minggu = uk ? uk.minggu : null;
      haid.uk_hari = uk ? uk.hari : null;
      haid.trimester = this.trimesterComputed;
      haid.status_kehamilan = this.statusKehamilanComputed;
    }

    // Sinkronkan flag oedem (legacy) dengan lokasi edema terstruktur
    const ekstr = contentFields.pemeriksaan_fisik?.umum?.ekstremitas;
    if (ekstr) {
      ekstr.oedem =
        ekstr.oedem ||
        (Array.isArray(ekstr.oedema_lokasi) && ekstr.oedema_lokasi.length > 0);
    }

    return {
      register_id: parseInt(this.register),
      pasien_rm: this.rm,
      unit_id: (this.stateuser && this.stateuser.unit_id) || "",
      content: contentFields,
      examined_at: `${examined_date} ${examined_time}:00`,
      bidan_user_id
    };
  }

  async simpan() {
    if (this.readOnly) return;
    this.saving = true;
    try {
      const payload = this.buildPayload();
      let resp;

      if (this.isEditing && this.record) {
        resp = await AsesmenAwalRanapKebidananSvc.update(
          this.record.id,
          payload
        );
      } else {
        resp = await AsesmenAwalRanapKebidananSvc.create(payload);
      }

      if (String(resp.status) === "1") {
        appModule.NoticeDelay(
          this.isEditing
            ? "Asesmen berhasil diperbarui"
            : "Asesmen berhasil disimpan"
        );
        this.isEditing = false;
        await this.loadData();
      }
    } finally {
      this.saving = false;
    }
  }

  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const signMap: any = {
      bidan: AsesmenAwalRanapKebidananSvc.signBidan,
      dpjp: AsesmenAwalRanapKebidananSvc.signDpjp,
      bpja: AsesmenAwalRanapKebidananSvc.signBpja
    };
    const labelMap: any = { bidan: "Bidan", dpjp: "DPJP", bpja: "BPJA" };
    const signFn =
      signMap[this.signRole] || AsesmenAwalRanapKebidananSvc.signDpjp;

    try {
      const resp = await signFn(this.record.id, { password });
      if (String(resp.status) === "1") {
        this.modalTtd = false;
        const label = labelMap[this.signRole] || "DPJP";
        appModule.NoticeDelay(`Berhasil Tanda Tangan ${label}`);
        appModule.addMsgTtd("");
        await this.loadData();
      } else {
        appModule.addMsgTtd(resp.message);
        this.modalTtd = true;
      }
    } catch {
      // handled by service
    }
  }

  cetakPdf() {
    if (this.record) {
      AsesmenAwalRanapKebidananSvc.printPdf(this.record.id);
    }
  }

  async hapus() {
    if (this.readOnly) return;
    const q = confirm(
      "Anda yakin akan menghapus Asesmen Awal Ranap Kebidanan ini?"
    );
    if (!q) return;

    try {
      const resp = await AsesmenAwalRanapKebidananSvc.destroy(this.record.id);
      if (resp && resp.status == 1) {
        appModule.NoticeDelay("Berhasil menghapus data");
        await this.loadData();
      }
    } catch {
      // handled by service
    }
  }
}
